module.exports = __webpack_public_path__ + "assets/img/activity_empty.e5f8490e.svg";